<div class="statement-generation-details-container">
  <div class="card">
    <!-- Header -->
    <div class="card-header bg-header" style="background-color: rgb(105, 69, 175) !important;">
      <div class="header-content">
        <div class="header-title">
          <h4 class="text-white m-0">
            <mat-icon class="mr-2">history</mat-icon>
            Dettagli Generazione Statement
          </h4>
        </div>
        <div class="header-actions" *ngIf="generationDetails">
          <button
            mat-raised-button
            color="accent"
            (click)="exportStatements('json')"
            class="mr-2">
            <mat-icon>download</mat-icon>
            Export JSON
          </button>
          <button
            mat-raised-button
            color="accent"
            (click)="exportStatements('csv')">
            <mat-icon>download</mat-icon>
            Export CSV
          </button>
        </div>
      </div>
    </div>

    <div class="card-body">
      <!-- Loading State -->
      <div *ngIf="loading" class="text-center py-5">
        <mat-spinner diameter="50"></mat-spinner>
        <p class="mt-3">Caricamento in corso...</p>
      </div>

      <!-- Error State -->
      <div *ngIf="error && !loading" class="alert alert-danger">
        <mat-icon>error</mat-icon>
        {{ error }}
      </div>

      <!-- Content -->
      <div *ngIf="!loading && !error && generationDetails">
        <!-- Generation Info Card -->
        <div class="info-card mb-4">
          <div class="info-header">
            <div class="info-title">
              <mat-icon>description</mat-icon>
              <h5>{{ generationDetails.name }}</h5>
            </div>
            <span class="badge" [ngClass]="getStatusBadgeClass(generationDetails.status)">
              <mat-icon class="badge-icon">{{ getStatusIcon(generationDetails.status) }}</mat-icon>
              {{ getStatusLabel(generationDetails.status) }}
            </span>
          </div>

          <div class="info-details">
            <div class="info-item">
              <mat-icon class="info-icon">schedule</mat-icon>
              <span><strong>Creato:</strong> {{ generationDetails.created_at | date:'dd/MM/yyyy HH:mm' }}</span>
            </div>
            <div class="info-item" *ngIf="generationDetails.completed_at">
              <mat-icon class="info-icon">done</mat-icon>
              <span><strong>Completato:</strong> {{ generationDetails.completed_at | date:'dd/MM/yyyy HH:mm' }}</span>
            </div>
            <div class="info-item">
              <mat-icon class="info-icon">input</mat-icon>
              <span><strong>Documenti Input:</strong> {{ generationDetails.input_sources?.length || 0 }}</span>
            </div>
            <div class="info-item">
              <mat-icon class="info-icon">fact_check</mat-icon>
              <span><strong>Statement Generati:</strong> {{ generationDetails.statements?.length || 0 }}</span>
            </div>
          </div>

          <!-- Progress Bar (for processing) -->
          <div *ngIf="generationDetails.status === 'processing'" class="mt-3">
            <mat-progress-bar
              mode="determinate"
              [value]="generationDetails.progress_percentage"
              color="accent">
            </mat-progress-bar>
            <small class="text-muted">{{ generationDetails.progress_percentage }}% Completato</small>
          </div>

          <!-- Error Message (for failed) -->
          <div *ngIf="generationDetails.status === 'failed' && generationDetails.error_message" class="alert alert-danger mt-3 mb-0">
            <mat-icon>error</mat-icon>
            {{ generationDetails.error_message }}
          </div>
        </div>

        <!-- Input Sources Section -->
        <div class="section-card mb-4">
          <div class="section-header">
            <h5>
              <mat-icon>input</mat-icon>
              Documenti e Fonti Utilizzate
            </h5>
          </div>

          <div class="section-content">
            <!-- Surveys -->
            <div *ngIf="inputSourcesByType.surveys.length > 0" class="source-type-group mb-3">
              <h6 class="source-type-title">
                <mat-icon>poll</mat-icon>
                Survey ({{ inputSourcesByType.surveys.length }})
              </h6>
              <div class="source-list">
                <div *ngFor="let source of inputSourcesByType.surveys" class="source-item">
                  <mat-icon class="source-icon">poll</mat-icon>
                  <div class="source-info">
                    <strong>{{ source.name }}</strong>
                    <div class="source-metadata" *ngIf="source.metadata">
                      <span *ngIf="source.metadata.surveyId">ID: {{ source.metadata.surveyId }}</span>
                      <span *ngIf="source.metadata.participants">Partecipanti: {{ source.metadata.participants }}</span>
                      <span *ngIf="source.metadata.uploadDate">{{ source.metadata.uploadDate | date:'dd/MM/yyyy' }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- PDFs -->
            <div *ngIf="inputSourcesByType.pdfs.length > 0" class="source-type-group mb-3">
              <h6 class="source-type-title">
                <mat-icon>picture_as_pdf</mat-icon>
                Documenti PDF ({{ inputSourcesByType.pdfs.length }})
              </h6>
              <div class="source-list">
                <div *ngFor="let source of inputSourcesByType.pdfs" class="source-item">
                  <mat-icon class="source-icon">picture_as_pdf</mat-icon>
                  <div class="source-info">
                    <strong>{{ source.name }}</strong>
                    <div class="source-metadata" *ngIf="source.metadata">
                      <span *ngIf="source.metadata.size">Dimensione: {{ source.metadata.size }}</span>
                      <span *ngIf="source.metadata.uploadDate">{{ source.metadata.uploadDate | date:'dd/MM/yyyy' }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- PubMed -->
            <div *ngIf="inputSourcesByType.pubmed.length > 0" class="source-type-group mb-3">
              <h6 class="source-type-title">
                <mat-icon>science</mat-icon>
                Articoli PubMed ({{ inputSourcesByType.pubmed.length }})
              </h6>
              <div class="source-list">
                <div *ngFor="let source of inputSourcesByType.pubmed" class="source-item">
                  <mat-icon class="source-icon">science</mat-icon>
                  <div class="source-info">
                    <strong>{{ source.name }}</strong>
                    <div class="source-metadata" *ngIf="source.metadata">
                      <a *ngIf="source.metadata.url" [href]="source.metadata.url" target="_blank" class="pubmed-link">
                        Visualizza su PubMed
                        <mat-icon class="external-link-icon">open_in_new</mat-icon>
                      </a>
                      <span *ngIf="source.metadata.uploadDate">{{ source.metadata.uploadDate | date:'dd/MM/yyyy' }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- GRADE Revisions -->
            <div *ngIf="inputSourcesByType.grades.length > 0" class="source-type-group mb-3">
              <h6 class="source-type-title">
                <mat-icon>grading</mat-icon>
                Revisioni GRADE ({{ inputSourcesByType.grades.length }})
              </h6>
              <div class="source-list">
                <div *ngFor="let source of inputSourcesByType.grades" class="source-item">
                  <mat-icon class="source-icon">grading</mat-icon>
                  <div class="source-info">
                    <strong>{{ source.name }}</strong>
                    <div class="source-metadata" *ngIf="source.metadata">
                      <span *ngIf="source.metadata.revisionId">ID: {{ source.metadata.revisionId }}</span>
                      <span *ngIf="source.metadata.uploadDate">{{ source.metadata.uploadDate | date:'dd/MM/yyyy' }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Other -->
            <div *ngIf="inputSourcesByType.other.length > 0" class="source-type-group mb-3">
              <h6 class="source-type-title">
                <mat-icon>description</mat-icon>
                Altro ({{ inputSourcesByType.other.length }})
              </h6>
              <div class="source-list">
                <div *ngFor="let source of inputSourcesByType.other" class="source-item">
                  <mat-icon class="source-icon">description</mat-icon>
                  <div class="source-info">
                    <strong>{{ source.name }}</strong>
                  </div>
                </div>
              </div>
            </div>

            <!-- Empty state -->
            <div *ngIf="!generationDetails.input_sources || generationDetails.input_sources.length === 0" class="text-center py-4">
              <mat-icon style="font-size: 3rem; height: 3rem; width: 3rem; color: #ccc;">input</mat-icon>
              <p class="text-muted mt-2">Nessun documento input</p>
            </div>
          </div>
        </div>

        <!-- Statements Section -->
        <div class="section-card">
          <div class="section-header">
            <h5>
              <mat-icon>fact_check</mat-icon>
              Statement Generati
            </h5>
            <div class="view-toggle" *ngIf="generationDetails.statements && generationDetails.statements.length > 0">
              <button
                mat-button
                [color]="viewMode === 'all' ? 'primary' : ''"
                (click)="viewMode = 'all'">
                <mat-icon>view_list</mat-icon>
                Vista Elenco
              </button>
              <button
                mat-button
                [color]="viewMode === 'by-section' ? 'primary' : ''"
                (click)="viewMode = 'by-section'">
                <mat-icon>view_module</mat-icon>
                Per Sezione
              </button>
            </div>
          </div>

          <div class="section-content">
            <!-- All Statements View -->
            <div *ngIf="viewMode === 'all'" class="statements-table-container">
              <table class="table table-hover" *ngIf="generationDetails.statements && generationDetails.statements.length > 0">
                <thead>
                  <tr>
                    <th style="width: 5%;">ID</th>
                    <th style="width: 10%;">Sezione</th>
                    <th style="width: 35%;">Statement</th>
                    <th style="width: 25%;">Commento</th>
                    <th style="width: 10%;">Livello</th>
                    <th style="width: 10%;">Grado</th>
                    <th style="width: 5%;">Score</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let statement of generationDetails.statements">
                    <td>{{ statement.id }}</td>
                    <td>
                      <span class="badge badge-info" *ngIf="statement.section">{{ statement.section }}</span>
                      <span class="text-muted" *ngIf="!statement.section">-</span>
                    </td>
                    <td>{{ statement.statement_text }}</td>
                    <td>{{ statement.comment }}</td>
                    <td><span class="badge badge-secondary">{{ statement.level_of_evidence }}</span></td>
                    <td><span class="badge badge-success">{{ statement.grade_of_recommendation }}</span></td>
                    <td>
                      <span *ngIf="statement.confidence_score">{{ (statement.confidence_score * 100).toFixed(0) }}%</span>
                      <span class="text-muted" *ngIf="!statement.confidence_score">-</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- By Section View -->
            <div *ngIf="viewMode === 'by-section'" class="statements-by-section">
              <div *ngFor="let section of sections" class="section-group mb-4">
                <h6 class="section-group-title">
                  <mat-icon>folder</mat-icon>
                  {{ section }}
                  <span class="badge badge-primary ml-2">{{ statementsBySection[section].length }}</span>
                </h6>
                <div class="statements-list">
                  <div *ngFor="let statement of statementsBySection[section]" class="statement-card">
                    <div class="statement-header">
                      <span class="statement-id">#{{ statement.id }}</span>
                      <div class="statement-badges">
                        <span class="badge badge-secondary">{{ statement.level_of_evidence }}</span>
                        <span class="badge badge-success">{{ statement.grade_of_recommendation }}</span>
                        <span class="badge badge-info" *ngIf="statement.confidence_score">
                          {{ (statement.confidence_score * 100).toFixed(0) }}%
                        </span>
                      </div>
                    </div>
                    <div class="statement-text">{{ statement.statement_text }}</div>
                    <div class="statement-comment" *ngIf="statement.comment">
                      <mat-icon class="comment-icon">comment</mat-icon>
                      {{ statement.comment }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Empty state -->
            <div *ngIf="!generationDetails.statements || generationDetails.statements.length === 0" class="text-center py-5">
              <mat-icon style="font-size: 4rem; height: 4rem; width: 4rem; color: #ccc;">fact_check</mat-icon>
              <h5 class="mt-3">Nessuno statement generato</h5>
              <p class="text-muted">Non sono stati ancora generati statement per questa generazione.</p>
            </div>
          </div>
        </div>

        <!-- Back Button -->
        <div class="row justify-content-center my-3">
          <a mat-button color="warn" (click)="goBack()" class="mr-2">
            <mat-icon class="mr-1">arrow_back</mat-icon>
            {{ "generic.buttons.cancel-and-back" | translate }}
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
